/* eslint-disable no-console */
import { EventType, useTracking } from '#core/Tracking';

export type Logger = {
  info: (message: string) => void;
  error: (message: string | Error) => void;
  warn: (message: string) => void;
  log: (message: string) => void;
};

const useLogger = (): Logger => {
  const { trackEvent } = useTracking();
  return {
    info: (message: string) => {
      console.info(message);
    },

    error: (message: string | Error) => {
      console.error(message);
      trackEvent({
        type: EventType.ERROR,
        payload: {
          id: typeof message === 'string' ? 'error' : message.name,
          type: typeof message === 'string' ? 'error' : message.name,
          message: typeof message === 'string' ? message : message.message,
        },
      });
      if (message instanceof Error) {
        setTimeout(() => {
          document.dispatchEvent(
            new CustomEvent('datapoints-error', { detail: message }),
          );
        }, 0);
      }
    },

    warn: (message: string) => {
      console.warn(message);
    },

    log: (message: string) => {
      console.log(message);
    },
  };
};

export default useLogger;
